import React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeSanitize from 'rehype-sanitize'

interface MarkdownRendererProps {
  rawText: string
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({ rawText }) => {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeSanitize]}
      skipHtml
      components={{
        p({ children }) {
          return <p className="mb-2">{children}</p>
        },

        strong({ children }) {
          return <strong className="fw-bold">{children}</strong>
        },

        em({ children }) {
          return <em className="fst-italic">{children}</em>
        },

        ul({ children }) {
          return <ul className="ms-3">{children}</ul>
        },

        ol({ children }) {
          return <ol className="ms-3">{children}</ol>
        },

        li({ children }) {
          return <li className="mb-1">{children}</li>
        },

        a({ href, children }) {
          return (
            <a
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary text-decoration-underline"
            >
              {children}
            </a>
          )
        },

        code({ inline, className, children, ...props }: any) {
          const content = String(children).trim()

          if (inline) {
            return (
              <code className="bg-light px-1 py-0 rounded small">
                {content}
              </code>
            )
          }

          return (
            <pre className="bg-dark text-white p-3 rounded small overflow-auto">
              <code>{content}</code>
            </pre>
          )
        },
      }}
    >
      {rawText}
    </ReactMarkdown>
  )
}
